import { makeStyles } from '@material-ui/styles';
import Barcode from 'react-barcode';

import '../../assets/css/print-landscape.css';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        pageBreakAfter: 'auto'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        pageBreakInside: 'avoid',
    },
    description: {
        color: '#283851',
        paddingLeft: 20
    }
}));

const ProductSaleBarcodeToPrint = ({ data }) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div>
                {
                    data?.map(productSale => {
                        return (
                            <div key={productSale.idemployee} className={classes.container}>
                                <Barcode value={productSale.code} />
                                <h3 className={classes.description}>{productSale.description}</h3>
                            </div>
                        );
                    })
                }
            </div>
        </div >
    );
}

export default ProductSaleBarcodeToPrint;